export default "__VITE_ASSET__CPbtSbhO__"